import styled from "styled-components";
import { InputText } from "../Inputs/InputText";
export const Input = styled(InputText)(({ theme: { fontSizes, space } }) => ({
    flex: 1,
    fontSize: fontSizes[1],
    paddingBottom: space[1],
    paddingLeft: space[0],
    paddingRight: space[0],
    paddingTop: space[1],
    width: "100%",
}));
